import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppTitle: React.FC = () => {
    const location = useLocation();

    const changeFavicon = (faviconUrl: string) => {
        let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");

        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }

        link.href = faviconUrl;
    };

    useEffect(() => {
        const baseTitle = "CappellusWeb";
        const titles: Record<string, string> = {
            "/": "",
            "/home": "- Home",
            "/dashboard": "- Dashboard",
            "/clientes": "- Clientes",
            "/usuarios": "- Usuários",
            "/produtos": "- Produtos",
            "/pedidos": "- Pedidos",
            "/configuracoes": "- Configurações",
            "/usuarios/novo": "- Novo Usuário",
            "/clientes/novo": "- Novo Cliente",
            "/produtos/novo": "- Novo Produto",
            "/pedidos/novo": "- Novo Pedido",
        };

        let appTitle = titles[location.pathname] ?? "";

        // Detectando páginas de edição
        if (location.pathname.match(/^\/usuarios\/[^/]+\/edit$/)) appTitle = "- Editar Usuário";
        if (location.pathname.match(/^\/clientes\/[^/]+\/edit$/)) appTitle = "- Editar Cliente";
        if (location.pathname.match(/^\/produtos\/[^/]+\/edit$/)) appTitle = "- Editar Produto";
        if (location.pathname.match(/^\/pedidos\/[^/]+\/edit$/)) appTitle = "- Editar Pedido";

        document.title = `${baseTitle} ${appTitle}`;

        // Define um único ícone para todas as páginas
        changeFavicon("/favicon.png");

    }, [location]);
    

    return null;
};

export default AppTitle;
